/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useCallback, useEffect, useMemo } from 'react';
import { deleteCookie, getCookie, setCookie } from '../UtilityFunctions';
import { SINGLE_TAB_COOKIE } from '../../contracts/constants';

export const useSingleTab = () => {
  const TWO_MINUTES = 2 / (24 * 60);
  const isSecondTab = useMemo(() => getCookie(SINGLE_TAB_COOKIE), []);

  const getIsSecondTab = useCallback(() => {
    if (isSecondTab) return true;
    setCookie(SINGLE_TAB_COOKIE, 'true', TWO_MINUTES);
    return false;
  }, [isSecondTab]);

  useEffect(() => {
    // Check if the cookie is already set
    if (isSecondTab) return;

    setCookie(SINGLE_TAB_COOKIE, 'true', TWO_MINUTES);

    const interval = setInterval(() => {
      setCookie(SINGLE_TAB_COOKIE, 'true', TWO_MINUTES);
    }, 1 * 60 * 1000); // Refresh cookie every 1 min

    // Clean up: Remove the cookie when the tab is closed
    // NOTE: we cannot check beforeunload/unload since this is not
    // supported by iOS Safari browser. Updated this to listen for pagehide
    // According to mdn web docs, beforeunload event listeners also prevent
    // pages from being placed in the bfcache on Firefox, so pagehide is
    // best practice for cross-browser compatibility.
    const handlePagehide = () => {
      deleteCookie(SINGLE_TAB_COOKIE);
    };

    window.addEventListener('pagehide', handlePagehide);
    return () => {
      clearInterval(interval);
      handlePagehide();
      window.removeEventListener('pagehide', handlePagehide);
    };
  }, [isSecondTab]);

  return { getIsSecondTab };
};
